module.exports = __webpack_public_path__ + "static/img/bg-1.f24aa5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-1.png
// module id = AYSX
// module chunks = 0